import WorkTitle from "./WorkTitle";
import ProjectComponent from "./Project";
import projects from "../../data/Projects";

const Work = () => {
  return (
    <div>
      <WorkTitle title="MY WORK" />
      {projects.map((project, i) => (
        <ProjectComponent
          title={project.title}
          key={i}
          data={project.data}
          index={i}
          pic={project.url}
          image={project.image}
        />
      ))}
    </div>
  );
};

export default Work;
